// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Gh","contentWrapCtaDefault":"Hh","disabled":"Ih","contentWrapCtaWhite":"Jh","promos":"Kh","lazyPromo":"Lh","mainContent":"Mh","headingText":"Nh","copy":"Oh","subtext":"Ph"};